<script lang="ts">
  // *** This file is part of DbGate Premium ***

  import { ProcessedChart } from 'dbgate-datalib';
  import ChartDisplay from './ChartDisplay.svelte';

  export let charts: ProcessedChart[] = [];
  export let onChoose;

  /* pick a layout class based on how many charts we’ll actually render
     – capped at 6 because the design never shows more than that */
  $: count = Math.min(charts.length, 6);
  $: layoutClass = `count-${count}`;
  $: displayedCharts = charts.slice(0, count);
</script>

<div class={`charts ${layoutClass}`}>
  {#each displayedCharts as chart, index}
    <div class="chart" on:click={() => onChoose(chart)} data-testid={`ChartSelector_chart_${index}`}>
      <ChartDisplay {chart} />
    </div>
  {/each}
</div>

<style>
  /* ---------- shared wrapper settings ---------- */
  .charts {
    width: 100%;
    height: 100%;
    gap: 1rem; /* space between charts – tweak as you like */
  }

  /* ---------- 1 chart : flex ---------- */
  .count-1 {
    display: flex;
  }
  .count-1 .chart {
    flex: 1 1 auto; /* fill the wrapper */
  }

  /* ---------- 2-to-6 charts : CSS Grid ---------- */
  .count-2,
  .count-3,
  .count-4,
  .count-5,
  .count-6 {
    display: grid;
  }

  /* 2 charts → two equal columns */
  .count-2 {
    grid-template-columns: repeat(2, 1fr);
  }

  /* 3 charts → one row, three equal columns */
  .count-3 {
    grid-template-columns: repeat(3, 1fr);
  }

  /* 4 charts → 2 × 2 grid */
  .count-4 {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
  }

  /* 5 charts → 3 × 2 grid, auto-packing so row 1 has 3 items,
     row 2 gets the remaining 2 (no need for manual placement) */
  .count-5 {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-auto-flow: row dense;
  }

  /* 6 charts → 3 × 2 grid */
  .count-6 {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
  }

  /* every ChartDisplay stretches to fill its grid area */
  .chart {
    width: 100%;
    height: 100%;
    display: flex;
  }
</style>
